<template>
  <div class="card card-fancy" :class="classes">
    <div class="card-header" v-if="hasHeaderSlot">
      <slot name="header"></slot>
      <slot name="header-actions"></slot>
    </div>

    <div class="card-content">
      <slot></slot>
    </div>

    <div class="card-footer" v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppCard",

  props: {
    dark: {
      type: Boolean,
      default: false,
    },

    blue: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    classes() {
      const classes = [];
      if (this.dark) {
        classes.push('card-dark');
      }

      if (this.blue) {
        classes.push('card-blue');
      }

      return classes;
    },

    hasHeaderSlot() {
      return this.$slots['header'] || this.$slots['header-actions'];
    },

    hasFooterSlot() {
      return this.$slots['footer'];
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/AppCard.vue